import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'

import { useNodeParams } from '../../hooks/useNodeParams'
import { AvailableComponentTypes, PageNodeViewModel } from '../../types'

import styles from './styles.module.scss'
import Image from 'next/image'

interface Props {
	node: PageNodeViewModel
}

export const NodeMain = ({ node }: Props) => {
	const nodeParams = useNodeParams(node.value.nodeParam)
	return (
		<BlockMain
			buttonProps={{
				onClick: scrollToApplicationForm,
			}}
			data={{
				title: nodeParams.get(AvailableComponentTypes.title),
				textItems: nodeParams.get(AvailableComponentTypes.stringArray, '').split('\n'),
				imageAlt: 'image alt',
				buttonText: 'Оставить заявку',
				subtitle: nodeParams.get(AvailableComponentTypes.description),
				customImage: (
					<Image
						alt=''
						fill
						className={styles.imgWrapper}
						src={nodeParams.get(AvailableComponentTypes.url)}
					/>
				),
				jsonData: JSON.parse(nodeParams.get(AvailableComponentTypes.json, '{}')),
			}}
		/>
	)
}
